export const profileRoutes = {
  update: '/api/v1/profile',
}
